import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TMainMenuLinkDesktop } from '../models';

export const MainMenuLinkDesktop: FC<TMainMenuLinkDesktop> = ({
    CommonLink,
    DataLayer,
    DropDown,
    IconChevronUp,
    analytics,
    dataTestId,
    dropDownData,
    isActive,
    link,
    pageId,
    styles,
    theme,
    title,
}) => (
    <li className={styles.mainMenuLinkContainer} data-test-id={dataTestId}>
        <DataLayer data={analytics}>
            <CommonLink
                className={cn(styles.mainMenuLink, styles[theme], {
                    [styles.active]: isActive,
                })}
                dataTestId={`mainMenuLink-${dataTestId}`}
                link={link}
                title={title}
            >
                {title}
            </CommonLink>
        </DataLayer>
        {dropDownData && (
            <>
                <IconChevronUp
                    className={cn(styles.iconChevron, styles[theme], {
                        [styles.active]: isActive,
                    })}
                />
                <DropDown
                    dataTestId={`${dataTestId}-dropDown`}
                    dropDownData={dropDownData}
                    pageId={pageId}
                    theme={theme}
                />
            </>
        )}
    </li>
);
